import { Hexagon } from "lucide-react";

export default function BeeRating({ value = 3, label = "Intensité" }) {
  return (
    <div className="flex items-center gap-2" data-testid="bee-rating" aria-label={`${label} : ${value} sur 5`}>
      <span className="text-xs uppercase tracking-[0.15em] text-stone-mute">{label}</span>
      <div className="flex items-center gap-1">
        {[1, 2, 3, 4, 5].map((i) => (
          <Hexagon
            key={i}
            size={15}
            className={i <= value ? "fill-honey text-honey" : "text-amber-900/20"}
          />
        ))}
      </div>
    </div>
  );
}
